export default "__VITE_ASSET__B3NECRg7__"